import angular from 'angular';

export default angular.module('shared').constant('alertLevelConstants', {
    none: 'None',
    information: 'Information',
    warning: 'Warning',
    hazard: 'Hazard',
    critical: 'Critical'
});



// WEBPACK FOOTER //
// ./modules/shared/constants/alertLevel.constant.js